module.exports = __webpack_public_path__ + "media/images/flags/kw-99541ad4cbf69050c95e6405815fee59.svg";